import { type FeatureModule } from '@store/features/types';

/**
 * Billing Readiness feature module definition
 *
 * This feature orchestrates readiness checks across org, entity, payer, and claim levels.
 * The feature uses RTK Query for all data fetching and caching.
 */
export const billingReadinessFeature: FeatureModule = {
  // Basic feature identification
  id: 'billingReadiness',
  name: 'Billing Readiness',

  // Depends on all billing-related features
  dependencies: ['stediConnection', 'billingEntities', 'enrollments'],

  // No reducers needed - this is an API-only feature
  reducers: {},

  // No middleware needed - API middleware is registered globally
  middleware: [],

  // No persistence needed for this API-only feature
  persistence: {
    enabled: false,
  },

  // No sync needed for this API-only feature
  sync: {
    enabled: false,
  },

  // Feature lifecycle hooks
  setup: _store => {
    // Feature initialization logic if needed
  },

  cleanup: _store => {
    // Feature cleanup logic if needed
  },
};
